import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { NavLink } from '@remix-run/react';
export default function LosseLink(props) {
    // If link contains src render as LosseLink with correct props
    if ('src' in props && !!props.src) {
        const link = { ...props };
        const { src, ...rest } = link;
        delete link.src;
        return (_jsx(LosseLink, { to: (src === null || src === void 0 ? void 0 : src.url) || '', target: (src === null || src === void 0 ? void 0 : src.target) || '', ...rest, children: (src === null || src === void 0 ? void 0 : src.title) || '' }));
    }
    // Comment for commit
    if ('onClick' in props && !!props.onClick) {
        const { type, children, ...rest } = { ...props };
        return (_jsx("button", { type: type || 'button', ...rest, children: children }));
    }
    const { className, children, external = ['https://', 'http://', 'tel:', 'mailto:', 'whatsapp:', 'fax:'], ...rest } = { ...props };
    // If link contains external url then render as anchor
    if (isExternal(external, rest.to)) {
        return (
        // @ts-ignore
        _jsx("a", { href: rest.to, ...props, children: children }));
    }
    if (!rest.to) {
        // @ts-ignore
        return _jsx("span", { ...props, children: children });
    }
    return (
    // @ts-ignore
    _jsx(NavLink, { prefetch: "none", className: ({ isActive }) => `${isActive ? 'active ' : ''}${className || ''}`, ...rest, children: children }));
}
export const isExternal = (external, url) => {
    if (!url) {
        return false;
    }
    if (typeof url !== 'string') {
        return false;
    }
    let response = false;
    external.forEach((check) => {
        if (url.includes(check)) {
            response = true;
        }
    });
    return response;
};
export const losseLinkFragment = `
  url
  target
  title
`;
